import 'polyfill-array-includes';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider, useDispatch } from 'react-redux';
import { datadogLogs } from '@datadog/browser-logs';
import { generateUUID } from './src/helpers/utilCommon';
import { FlagFeaturesProvider } from './src/providers/flagFeature';
import * as serviceWorker from './src/serviceWorker';
import store from './src/store';
import App from 'components/pages/app';
import ErrorBoundary from 'components/organisms/ErrorBoundary';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'astm-ux-design-system/dist/bundle.css';
import './src/assets/themes/main.css';
import './src/index.css';
import { getAuthKeys } from './src/services/appServices';
import { decryptTokens } from './src/helpers/utilCommon';

(() => {
    let isJiraEnabled = process.env.REACT_APP_JIRA_ISSUE_COLLECTOR_ENABLED;
    if (isJiraEnabled === 'true') {
        let src = process.env.REACT_APP_JIRA_ISSUE_COLLECTOR_URL;
        document.write('<script src="' + src + '"><\/script>');
    }
})();

const uniqueId = generateUUID();


const initializeDatadog = (clientToken) => {
    if (!clientToken || datadogLogs.getInitConfiguration()) {
        return;
    }

    datadogLogs.init({
        clientToken,
        site: process.env.REACT_APP_DATADOG_SITE,
        service: process.env.REACT_APP_DATADOG_SERVICE,
        env: process.env.REACT_APP_DATADOG_ENV,
        forwardErrorsToLogs: true,
        forwardConsoleLogs: ['error', 'debug', 'info'],
        storeContextsAcrossPages: true,
        allowUntrustedEvents: true,
        sendLogsAfterSessionExpiration: true,
        beforeSend: (event) => {
            if (typeof event.message === 'string' &&
                event.message.startsWith('Warning:')) {
                return false;
            }

            if (typeof event.message === 'string') {
                event.message = `${uniqueId}:: ${event.message}`;
            }
        }
    });
};

const AppBootstrap = () => {
    const dispatch = useDispatch();
    const [ready, setIsReady] = useState(false);

    useEffect(() => {
        let isMounted = true;

        getAuthKeys(dispatch, (_isSuccess, _message, responseData) => {
            if (!isMounted) {
                return;
            }

            const authPayload =
                responseData?.data &&
                    typeof responseData.data === 'object' &&
                    !Array.isArray(responseData.data)
                    ? responseData.data
                    : responseData;

            const encryptedToken = authPayload?.REACT_APP_DATADOG_CLIENT_TOKEN;
            const encryptionKey = authPayload?.ENCRYPT_KEY;

            if (encryptedToken && encryptionKey) {
                const resolvedToken = decryptTokens(encryptedToken, encryptionKey);

                if (resolvedToken) {
                    initializeDatadog(resolvedToken);
                }
            }

            setIsReady(true);
        });

        return () => {
            isMounted = false;
        };
    }, [dispatch]);

    if (!ready) {
        return <></>;
    }

    return (
        <FlagFeaturesProvider>
            <Router basename="/">
                <App />
            </Router>
        </FlagFeaturesProvider>
    );
};

createRoot(document.getElementById('root')).render(
    <ErrorBoundary>
        <Provider store={store}>
            <AppBootstrap />
        </Provider>
    </ErrorBoundary>
);

serviceWorker.unregister();